//------------------------------------------------------------------------
// Card slider
// https://github.com/Threespot/pha-cms/issues/410
//------------------------------------------------------------------------
import Flickity from "flickity";

export default class CardCarousel {
  constructor(el) {
    let self = this;
    this.el = el;
    this.carousel = this.el.querySelector(".CardSlider-items");
    this.currentIndex = 0;

    this.flkty = new Flickity(this.carousel, {
      adaptiveHeight: false, // Changes height of carousel to fit height of selected slide.
      arrowShape: "M56.5 8.1a6.2 6.2 0 019.3 0l6 6a6.6 6.6 0 010 9.8L45.6 50.5l26.4 26.6a6.6 6.6 0 010 9.7l-6.1 6a6.2 6.2 0 01-9.3 0L19 55.4a6.6 6.6 0 010-9.6L56.5 8z",
      dragThreshold: 15, // improve UX on mobile devices when scrolling
      friction: 0.8,// Higher friction makes the slider feel stickier and less bouncy (default 0.28)
      groupCells: true,
      pageDots: false,
      prevNextButtons: true,
      selectedAttraction: 0.1,// Higher attraction makes the slider move faster (default 0.025)
      wrapAround: true,
      on: {
        ready: function() {
          self.onReadyCallback(this);
        }
      }
    });
  }

  onReadyCallback(flkty) {
    // NOTE: “this” refers to the Flickity object
    // Update “role” attribute to account for markup changes after Flickity inits
    // (Flickity doesn’t work with ul/li so we have to use divs with role attrs)
    flkty.element.removeAttribute("role");
    this.el.querySelector(".flickity-slider").setAttribute("role", "list");
  }
}

// Init
const init = () => {
  document.querySelectorAll(".CardSlider").forEach(el => new CardCarousel(el));
};

// Init on initial page load
init();